import React, { useEffect, useState } from "react";
import { find, get } from "lodash";
import { Tab, Tabs } from "react-bootstrap";
import {
  ManageCensusLayout,
  TabLeavingGuard,
  AddToolTip,
} from "../../../components";
import { useRouterParams, useRequest } from "../../../abstracts";
import Deferrals from "./Deferrals";
import DepositHistory from "./DepositHistory";
import EligibilityOverride from "./EligibilityOverride";
import Vesting from "./Vesting";
import Loans from "./Loans";
import PlanSummary from "./PlanSummary";
import Transactions from "./Transactions";
import { getNullTableItem, OPTIONS_DATA_MAPPER } from "../../../utils";
import { getPlanMetaData } from "../../../services";
import {
  FLOW_TYPES,
  ROUTES,
  MANAGE_CENSUS_ROUTES,
  getAdvancedPathWithParam,
} from "../../../utils";
import Retirement from "./Retirement";
import ManualEnrollmentContainer from "../ManualEnrollmentContainer";
import tenantConfig from "../../../mocks/tenantOne.json";
import permissions from "../../../mocks/menuPermissions.json";
import authService from "../../../components/api-authorization/AuthorizeService";

const EmployeeManagePlansContainer = (props) => {
  const { history } = props;
  const [keyValue, setkeyValue] = useState("eligibility_override");
  const [nextkeyValue, setNextkeyValue] = useState(keyValue);
  const [isInnerFormDirty, setIsInnerFormDirty] = useState(false);
  const { flow, censusId = 1, planId } = useRouterParams();
  const [newFlow, setNewFlow] = useState();
  const [roleName, setRoleName] = useState("VOU");

  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const { response: planDetails } = useRequest({
    method: getPlanMetaData,
    payload: planId,
  });
  const topPlanDetails = [
    {
      label: "Plan name",
      value: get(planDetails, "planName"),
    },
    {
      label: "Plan ID",
      value: get(planDetails, "planId"),
    },
    {
      label: "Plan Category",
      value: getNullTableItem(
        OPTIONS_DATA_MAPPER.PLAN_CATERGORY[get(planDetails, "planCategory")]
      ),
      // value: get(planDetails, "planCategory"),
    },
    {
      label: "Company Name",
      value: get(planDetails, "companyName"),
    },
  ];

  // const buttons =
  //   keyValue === "eligibility_override"
  //     ? [
  //         {
  //           link: ROUTES.MANAGE_EMPLOYEE,
  //           label: "Cancel",
  //           variant: "secondary",
  //           type: "button",
  //           flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
  //         },
  //         {
  //           label: "Save",
  //           variant: "primary",
  //           type: "submit",
  //           flow: [FLOW_TYPES.ADD],
  //           link: ROUTES.MANAGE_EMPLOYEE,
  //         },
  //         {
  //           label: "",
  //           variant: "link",
  //           type: "button",
  //           flow: [FLOW_TYPES.EDIT],
  //           icon: faTimes,
  //           link: ROUTES.MANAGE_EMPLOYEE,
  //         },
  //         {
  //           label: "",
  //           variant: "link",
  //           type: "button",
  //           flow: [FLOW_TYPES.EDIT],
  //           icon: faPencilAlt,
  //           onClick: () =>
  //             history.push(
  //               getAdvancedPathWithParam({
  //                 path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_PLAN_MODULES,
  //                 pathParam: [FLOW_TYPES.SAVE, censusId, planId],
  //               })
  //             ),
  //         },
  //         {
  //           label: "Save",
  //           variant: "primary",
  //           type: "submit",
  //           flow: [FLOW_TYPES.SAVE],
  //           // link: ROUTES.MANAGE_EMPLOYEE,
  //         },
  //       ]
  //     : [];

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  const menuList = [
    { id: "eligibilityOverride", label: "eligibilityOverride" },
    { id: "depositHistory", label: "depositHistory" },
    { id: "deferrals", label: "deferrals" },
    { id: "vesting", label: "vesting" },
    { id: "retirement", label: "retirement" },
  ];
  const menuChange = (key) => {
    setNextkeyValue(key);
  };

  const onClickEdit = () => {
    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_PLAN_MODULES,
        pathParam: [FLOW_TYPES.SAVE, censusId, planId],
      })
    );
  };

  const onClickSave = () => {
    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_PLAN_MODULES,
        pathParam: [FLOW_TYPES.EDIT, censusId, planId],
      })
    );
  };

  return (
    <div className="height-95vh">
      <ManageCensusLayout
        //buttons={buttons}
        buttons={[]}
        pageFlow={newFlow || flow}
        blockNavigation={isInnerFormDirty}
      >
        <div className="d-flex justify-content-between highlevel-plan-details w-50">
          {topPlanDetails.map((item) => (
            <div className="mr-3">
              <div className="plan-label">{item.label}</div>
              <div className="plan-value">
                <AddToolTip
                  style={{ textOverflow: "ellipsis", maxWidth: "150px" }}
                  name={item.value}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="mt-3">
          <Tabs
            defaultActiveKey="eligibility_override"
            transition={false}
            className="top-level-tab"
            onSelect={menuChange}
            activeKey={keyValue}
            mountOnEnter
            unmountOnExit
          >
            {/* <Tab eventKey="plan_summary" title="Plan summary">
              <PlanSummary />
            </Tab> */}
            {menuList
              .filter(
                (_) =>
                  tenantConfig.employeesManagePlanSubMenu.includes(_.id) &&
                  permissions[roleName].employeesManagePlanSubMenu[_.id]
              )
              .map((_) => {
                return _.id == "eligibilityOverride" ? (
                  <Tab
                    eventKey="eligibility_override"
                    title="Eligibility Override"
                  >
                    <EligibilityOverride
                      isEdit={isEdit}
                      isSave={isSave}
                      menu={"employees"}
                      subMenu={"employeeManagePlans"}
                      onClickEdit={onClickEdit}
                      onClickSave={onClickSave}
                      {...{ isInnerFormDirty, setIsInnerFormDirty }}
                    />
                  </Tab>
                ) : _.id == "deferrals" ? (
                  <Tab eventKey="deferrals" title="Deferral Election">
                    <ManualEnrollmentContainer></ManualEnrollmentContainer>
                  </Tab>
                ) : _.id == "depositHistory" ? (
                  <Tab eventKey="deposit_history" title="Deposit History">
                    <DepositHistory
                      {...{ isInnerFormDirty, setIsInnerFormDirty }}
                    />
                  </Tab>
                ) : _.id == "vesting" ? (
                  <Tab eventKey="vesting" title="Vesting">
                    <Vesting />
                  </Tab>
                ) : _.id == "retirement" ? (
                  <Tab eventKey="retirement" title="Retirement">
                    <Retirement />
                  </Tab>
                ) : null;
              })}
          </Tabs>
        </div>
      </ManageCensusLayout>
      <TabLeavingGuard
        {...{
          isInnerFormDirty,
          setIsInnerFormDirty,
          setkeyValue,
          nextkeyValue,
          setNextkeyValue,
          keyValue,
        }}
      />
    </div>
  );
};

export default EmployeeManagePlansContainer;
